/**
 * Resolve the best available logo from the org hierarchy.
 * Priority: company → portfolio/sub-org → client → null
 */
export function resolveOrgLogo(
  companyLogo?: string | null,
  portfolioLogo?: string | null,
  clientLogo?: string | null
): string | null {
  return companyLogo || portfolioLogo || clientLogo || null;
}
